import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type UpdatePinVisibilityRequest = {
  intervention_id: number;
  pin_id: number;
  visible_important_items: boolean;
};

export const useUpdatePinVisibilityMutation = () =>
  useTypedMutation<UpdatePinVisibilityRequest, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/pins/visibility", payload);
    },
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const interventionIdx = appointment.interventions.findIndex(intervention => intervention.id === payload.intervention_id);
      if (interventionIdx < 0) return;

      const intervention = appointment.interventions[interventionIdx];
      const history = intervention.pin_history;
      if (!history?.length) return;

      const pinIdx = history.findIndex(pin => pin.id === payload.pin_id);
      if (pinIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, {
          ...intervention,
          pin_history: history.with(pinIdx, { ...history[pinIdx], visible_important_items: payload.visible_important_items })
        })
      });
    }
  });
